<template>
        <div class="ep-slider-wrap">
            <h3>민선8기 공약 - {{selectedPromiseCategoryName}}
                <span class="sort-box2">
                    <a href="javascript:window.open('https://www.ep.go.kr/mayor/contents.do?key=3576', '_blank');" class="active">
                        홈페이지에서 보기</a>
                </span>
                <!--
                <div class="play_wrap">
                <span style="cursor: pointer;"
                    :class="isPlaySwiperBiz ? 'stop' : 'play'"
                    @click.prevent="toggleSwiperBiz"></span>
                </div>
                -->
            </h3>
            <div class="ep-slider">
                <swiper class="swiper" ref="swiper" :options="swiperOption">
                    <swiper-slide v-for="(promiseBusinessData, i) in promiseBusinessDatas" :key="i">
                        <div class="ep-box01">
                        <!-- <span href="#" @click.prevent="selectPromiseBusinessData(promiseBusinessData)"> -->
                        <a href="javascript:window.open('https://www.ep.go.kr/mayor/contents.do?key=3576', '_blank');">
                            <span class="flag pink">공약</span>
                            <div class="photo"><img :src="getImgUrl(promiseBusinessData)" @error="altImgUrl" :alt="promiseBusinessData.val2"></div>
                            <div class="title" :title="promiseBusinessData.val2">{{ promiseBusinessData.val2 }}</div>
                            <ul class="prograss-list">
                                <li><span class="title">총괄부서</span>{{ promiseBusinessData.val3 }}</li>
                                <li><span class="title">추진상태</span>{{ promiseBusinessData.val11 }}</li>
                            </ul>
                        </a>
                        </div>
                    </swiper-slide>
                    <div class="swiper-button-prev" id="prev1" slot="button-prev" ref="prev1"></div>
                    <div class="swiper-button-next" id="next1" slot="button-next" ref="next1"></div>
                </swiper>
            </div>
            <div class="sort-box">
                <a href="#" :class="selectedPromiseCategoryCode === 'A' ? 'active' : ''" @click.prevent="selectPromiseCategoryHandle('A')">경제·교통</a>
                <a href="#" :class="selectedPromiseCategoryCode === 'B' ? 'active' : ''" @click.prevent="selectPromiseCategoryHandle('B')">주거</a>
                <a href="#" :class="selectedPromiseCategoryCode === 'C' ? 'active' : ''" @click.prevent="selectPromiseCategoryHandle('C')">교육</a>
                <a href="#" :class="selectedPromiseCategoryCode === 'D' ? 'active' : ''" @click.prevent="selectPromiseCategoryHandle('D')">복지</a>
                <a href="#" :class="selectedPromiseCategoryCode === 'E' ? 'active' : ''" @click.prevent="selectPromiseCategoryHandle('E')">문화</a>
            </div>
             <transition name="modal">
                <PromiseCardWin v-if="isShowPromiseCardWin" :param-obj="paramObj" @close-promise-info-win="showPromiseCardWin(false)" />
            </transition>
        </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { $WC } from '@/conf/common.const.js';
import PromiseCardWin from '@/views/biz/PromiseCardWin.vue';

export default {
    name: 'promiseCard',
    data() {
        return {
            isPlaySwiperBiz: true,
            swiperOption: {
                slidesPerView: 4,
                spaceBetween: 30,
                autoplay: {
                    delay: $WC.FIVE_SEC_INTERVAL,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '#next1',
                    prevEl: '#prev1'
                },
                breakpoints: {
                    1020: {
                    slidesPerView: 4,
                    spaceBetween: 30
                    },
                    768: {
                    slidesPerView: 3,
                    spaceBetween: 20
                    },
                    480: {
                    slidesPerView: 2,
                    spaceBetween: 10
                    }
                }
            },
            selectedPromiseCategoryCode: "A",
            promiseBusinessDatas: [],
            isShowPromiseCardWin: false,
            paramObj: {
                dataKdSqno: '',
                dataSqno: ''
            }
        }
    },
    created() {
        // 공약사업 분류코드 목록
        this.$store.dispatch('FETCH_PROMISE_CATEGORY_LIST');

        // 공약사업 목록
        this.$store.dispatch('FETCH_PROMISE_BUSINESS_LIST')
            .then(() => {
                this.setPromiseBusinessDatas();
            });

    },
    computed: {
        ...mapGetters({
            promiseCategoryList: 'getPromiseCategoryList'

        }),

        selectedPromiseCategoryName() {
            let selectedPromiseCategoryName = '';
            this.promiseCategoryList.forEach((promiseCategory) => {
                if(promiseCategory.commonCode === this.selectedPromiseCategoryCode) selectedPromiseCategoryName = promiseCategory.commonCodeNm;
            })
            return selectedPromiseCategoryName;
        }

    },
    mounted() {

    },
    methods: {
        showPromiseCardWin(isShow) {
            this.isShowPromiseCardWin = isShow;
        },
        selectPromiseBusinessData(promise) {
            // this.paramObj.dataKdSqno = promise.dataKdSqno;
            // this.paramObj.dataSqno = promise.amnDataSqno;
            // this.showPromiseCardWin(true);
            // return this.paramObj;
            location.href = $WC.cp + "promiseDetail";
        },
        getGridSize() {
            return (window.innerWidth < 600) ? 2 : (window.innerWidth < 900) ? 3 : 4;
        },
        selectPromiseCategoryHandle(selectPromiseCategoryCode) {
            this.selectedPromiseCategoryCode = selectPromiseCategoryCode
            this.setPromiseBusinessDatas();
        },
        setPromiseBusinessDatas() {
            var promiseBusinessDatas = this.$store.getters.getPromiseBusinessDataMap[this.selectedPromiseCategoryCode];

            if(window.innerWidth >= 1020) {
               if(promiseBusinessDatas.length < 5) {
                this.$refs['prev1'].style.display = "none";
                this.$refs['next1'].style.display = "none";
                } else {
                    this.$refs['prev1'].style.display = "block";
                    this.$refs['next1'].style.display = "block";
                }
            } else if(window.innerWidth < 1020 && window.innerWidth >= 480) {
                if(promiseBusinessDatas.length < 4) {
                this.$refs['prev1'].style.display = "none";
                this.$refs['next1'].style.display = "none";
                } else {
                    this.$refs['prev1'].style.display = "block";
                    this.$refs['next1'].style.display = "block";
                }
            } else if(window.innerWidth < 480) {
                if(promiseBusinessDatas.length < 3) {
                this.$refs['prev1'].style.display = "none";
                this.$refs['next1'].style.display = "none";
                } else {
                    this.$refs['prev1'].style.display = "block";
                    this.$refs['next1'].style.display = "block";
                }
            }

            if (typeof promiseBusinessDatas === 'undefined') {
                this.promiseBusinessDatas = [];
            } else {
                this.promiseBusinessDatas = promiseBusinessDatas;
            }

        },
        getImgUrl(promise) {
            if (typeof promise.dataFiles !== 'undefined' && typeof promise.dataFiles[0] !== 'undefined') {
                return $WC.apiBaseURL + '/data/image/' + promise.dataFiles[0].comnFlSqno;
            } else {
                return $WC.cp + 'images/none_img2.png';
            }
        },
        altImgUrl(event) {
            event.target.src = $WC.cp + 'images/none_img2.png';
        },
        toggleSwiperBiz() {
            if(this.isPlaySwiperBiz) {
                // swiper 멈춤
                this.$refs.swiper.$swiper.autoplay.stop();
            } else {
                // swiper 시작
                this.$refs.swiper.$swiper.autoplay.start();
            }

            this.isPlaySwiperBiz = !this.isPlaySwiperBiz;
        }
    },
    components: {
        PromiseCardWin,
    },
}
</script>
